import getImageUrl from '~/util/imageUtils';
import { isSearchLocation } from '~/util/searchUtils';

import { SearchResultPageSearchResult } from '../contexts/SearchResultsPageContext';
import { VendorSearchRequest } from '../types/types';

/**
 * Returns the search location label if it's a state, market or city, or an empty string otherwise
 */
export const getLocation = (vendorSearch: VendorSearchRequest) => {
  const { selectedLocation } = vendorSearch;
  if (isSearchLocation(selectedLocation)) {
    return selectedLocation.label;
  }
  return '';
};

/**
 * Returns "in {location}" if a location is provided, or an empty string otherwise
 */
export const getInLocation = (location?: string | null) => {
  if (!location) {
    return '';
  }
  return ` in ${location}`;
};

/**
 * Retuns the URL of the first image in the search results
 */
export const getMetaImageUrl = (searchResults: SearchResultPageSearchResult) => {
  const vendor = searchResults.vendors[0];
  let imageUrl = undefined;
  if (vendor && 'imageIds' in vendor) {
    const imageIds = vendor.imageIds;
    if (Boolean(imageIds?.length)) {
      // Resize so its always a 4:3 (we don't enforce aspect ratios on upload)
      imageUrl = getImageUrl(imageIds[0]) + '?w=400&h=300&fit=crop&q=60&fm=webp';
    }
  }
  return imageUrl;
};
